/**
 * Shared form-validation copy. Feature-specific wording lives in that feature's
 * namespace; only rules reused across forms belong here.
 */
const validation = {
  required: '必須項目です',
  maxLength: '{{max}}文字以内で入力してください',
  minLength: '{{min}}文字以上で入力してください',
  integer: '整数を入力してください',
  range: '{{min}}〜{{max}}の範囲で入力してください',
  min: '{{min}}以上の値を入力してください',
  nonNegative: '0以上の値を入力してください',
  invalidId: 'IDの形式が正しくありません',
  invalidSelection: '選択された値が正しくありません',
  maxItems: '{{max}}件以内で選択してください',
};

export default validation;
